import { useAuth } from 'react-oidc-context';

/**
 * Replaces the analyze form when the visitor is not signed in (Slice 12 —
 * anonymous submission removed). Sits where the form would render so the
 * page still feels balanced; feeds below remain visible to anyone.
 */
export function SignInGate() {
  const auth = useAuth();
  return (
    <section className="mt-10 rounded-lg border border-primary/40 bg-primary/5 p-8 text-center">
      <h2 className="text-2xl font-bold text-foreground">🎣 Sign in to analyze</h2>
      <p className="mt-2 text-base text-muted-foreground">
        Score articles, images, and PDFs. Free with email or Google.
      </p>
      <ul className="mx-auto mt-6 w-fit space-y-1.5 text-left text-sm text-muted-foreground">
        <li className="flex items-center gap-2">
          <span aria-hidden>✓</span>
          <span>Up to 100 analyses per day</span>
        </li>
        <li className="flex items-center gap-2">
          <span aria-hidden>✓</span>
          <span>Claim a public username on your catches</span>
        </li>
        <li className="flex items-center gap-2">
          <span aria-hidden>✓</span>
          <span>Toggle each catch public or private</span>
        </li>
      </ul>
      <button
        type="button"
        onClick={() => auth.signinRedirect()}
        className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90"
      >
        Sign in
      </button>
    </section>
  );
}
